export default {
  state: {
    selection: {},
    defaultSelection: "5092",
    options: [],
  },

  mutations: {
    setSelection(state, selection) {
      state.selection = selection;
    },

    setDefaultSelection(state, defaultSelection) {
      state.defaultSelection = defaultSelection;
    },

    setOptions(state, options) {
      state.options = options;
    },
  },
};
